import { useEffect } from 'react';

import { useQueryParamValue } from 'src/app/shared/hooks/location';
import { useSessionAsync } from 'src/app/shared/hooks/session';
import { useTrackOnce } from 'src/app/shared/hooks/tracking';
import { isLoaded } from 'src/app/shared/utils/async';

export function useShowSurvey(): void {
	const trackOnce = useTrackOnce();
	const session = useSessionAsync();

	const petitionFeedback = useQueryParamValue('petition_feedback');
	const surveyEventUuid = useQueryParamValue('survey_event_uuid');

	useEffect(() => {
		if (isLoaded(session)) {
			// Only track if we come from a redirect from the middle-end that previously set the current_source property
			if (petitionFeedback === 'survey_feedback' && session.value.trackingData.current_source) {
				void trackOnce('survey_feedback', {
					survey_event_uuid: surveyEventUuid,
				});
			}
		}
	}, [session, petitionFeedback, surveyEventUuid, trackOnce]);
}
